module.exports = __webpack_public_path__ + "img/t1.2ee8469b.png";